import { render } from "./App.vue?vue&type=template&id=13f37dea&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=13f37dea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\uigb_new\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f37dea"]])

export default __exports__